// Empty stub for optional formstone touch module
// This module is intentionally empty as we don't want to use touch functionality
module.exports = {}; 
